module.exports = __webpack_public_path__ + "slide4-steps-ie11.029cd7afcf6b0061ca71b35b704b5133.hashedasset.svg";